module.exports = __webpack_public_path__ + "img/Details-Icon.48a2d84c.svg";